import { render, staticRenderFns } from "./SidGradient.vue?vue&type=template&id=0e124cb2"
import script from "./SidGradient.vue?vue&type=script&lang=js"
export * from "./SidGradient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports